var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13595 3.4805C5.52183 2.819 6.47763 2.819 6.86351 3.4805L8.62247 6.49587C9.01135 7.16253 8.53048 7.99974 7.75869 7.99974H7V17C7 18.1046 7.89543 19 9 19C10.1046 19 11 18.1046 11 17V7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7V15.1706C20.165 15.5825 20.9997 16.6936 20.9997 17.9998C20.9997 19.6566 19.6566 20.9998 17.9997 20.9998C16.3429 20.9998 14.9997 19.6566 14.9997 17.9998C14.9997 16.6934 15.8347 15.5821 17 15.1704V7C17 5.89543 16.1046 5 15 5C13.8954 5 13 5.89543 13 7V17C13 19.2091 11.2091 21 9 21C6.79086 21 5 19.2091 5 17V7.99974H4.24076C3.46897 7.99974 2.9881 7.16253 3.37699 6.49587L5.13595 3.4805ZM17.9774 17C17.4354 17.0119 16.9997 17.4549 16.9997 17.9998C16.9997 18.552 17.4474 18.9998 17.9997 18.9998C18.552 18.9998 18.9997 18.552 18.9997 17.9998C18.9997 17.4549 18.564 17.0119 18.022 17H17.9774Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.30cbb980a54b9cfc37d51faeba5bd6a7.svg";
export { ForwardRef as ReactComponent };